// Wait for collection filters and sort dropdown to appear
function cleanUpCollectionPage() {
  // SORT BY CLEANUP
  const sortDropdown = document.querySelector('select[name="sort_by"]');
  if(sortDropdown) {
    const keepSorts = ["created-descending","created-ascending","price-ascending","price-descending"];
    Array.from(sortDropdown.options).forEach(option => {
      if(!keepSorts.includes(option.value)) option.remove();
    });
  }

  // FILTER CLEANUP
  const filterGroups = document.querySelectorAll('[data-filter-group]');
  filterGroups.forEach(group => {
    const label = group.querySelector('.filter__heading')?.textContent?.trim();
    if(label !== "Product type" && label !== "Size") {
      group.remove();
    }
  });
}

// Run every 300ms until filters exist
const interval = setInterval(() => {
  if(document.querySelector('[data-filter-group]') || document.querySelector('select[name="sort_by"]')) {
    cleanUpCollectionPage();
    clearInterval(interval); // stop checking once done
  }
}, 300);
